import { Fragment, useState } from "react";
import React, { Component } from "react";
import {
  Dialog,
  Menu,
  Transition,
  Listbox,
  Combobox,
  Disclosure,
} from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import moment from "moment";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  PlusIcon,
  ArchiveIcon,
  SortAscendingIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  DocumentIcon,
  PlusSmIcon as PlusSmIconOutline,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  ArrowSmDownIcon,
  ArrowSmUpIcon,
  ScaleIcon,
  PlusSmIcon as PlusSmIconSolid,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";

import Vendorscreatemodal from "./Vendorscreatemodal";
import ItemModalcreate from "./ItemModalcreate";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Purchaseorder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      openitem: false,

      vendor_id: "",
      branch_id: "",
      purchase_order_date: "",
      expected_delivery_date: "",
      payment_terms_id: "",
      customer_notes: "",
      terms_conditions: "",
      adjustment_name: "",
      adjustment_value: "",
      balance_due: 0,
      sub_total: "",
      total: "",
      totalTax: 0,
      total_tax_amount: 0,
      invoiceTaxlist: [],
      purchase_order_item: [
        {
          name: "",
          item_id: "",
          hsn_code: "",
          description: "",
          quantity: 1,
          discount_symbol_id: 1,
          discount_number: 0,
          rate: 0,
          purchase_order_tax_id: 0,
          purchase_tax_orgin_percentage: 0,
          gst_igst_common_value: 0,
          cgst_percentage: 0,
          cgst_amount: 0,
          sgst_percentage: 0,
          sgst_amount: 0,
          igst_percentage: 0,
          igst_amount: 0,
          amount: 0,
        },
      ],
      vendorList: [],
      itemLine: [],
      termsList: [],
      branchList: [],
      error_list: [],
      discountList: [],
      warehouseList: [],
      employee_id:0,
      employeeList:[],
      query: "",
      queryItem: "",
      selectedPerson: "",
      selectedItems: "",
      openvendor: false,
      loader: "",
      overLay: "",
    };
    this.handleInput = this.handleInput.bind(this);
    //this.addLine = this.addLine.bind(this);
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open");
    this.setState({ sidebarOpen: true });
  };

  handleInputModal = (e) => {
    this.state.vendorList = [];
    if (e) {
      this.setState({ openvendor: false });
      const token = localStorage.getItem("token");
      const res = axios
        .get("public/api/vendors", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({ vendorList: res.data.vendors });
        });
    }
  };

  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const res = axios
      .get("public/api/vendors", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ vendorList: res.data.vendors });
      });

    const res2 = axios
      .get("public/api/paymentterms", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.setState({ termsList: res2.data.paymentterms });
      });

    const res3 = axios
      .get("public/api/invoice/tax/option", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res3) => {
        this.setState({ invoiceTaxlist: res3.data.invoice_tax_option });
      });

    const res12 = axios
      .get("public/api/branch", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res12) => {
        this.setState({ branchList: res12.data.branches });
      });

    const res13 = axios
      .get("public/api/invoice/discount/symbol", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res13) => {
        this.setState({ discountList: res13.data.discount_symbols });
      });

      const res14 = axios
      .get("public/api/employees", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res14) => {
        this.setState({ employeeList: res14.data.employees });
      });

    setTimeout(
      function () {
        //Start the timer
        this.closeLoaderFuncion();
        this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
  }

  handleInput = (e) => {
    this.setState({
      selectedPerson: e,
    });
    this.setState({ vendor_id: e.id });
  };

  handleInputSelectItem = (PurchaseItemIndex) => (e) => {
    /*const itemsP = this.state.purchase_order_item.map((item, sidx) => {
   
    if (index !== sidx) return item;
    return { ...item, name: e.name,hsn_code:e.hsn_code,item_id:e.id,rate:e.sales_selling_price,amount:e.sales_selling_price};
  });

  this.setState({item:itemsP});*/

    this.state.purchase_order_item[PurchaseItemIndex].name = e.name;
    //this.state.purchase_order_item[PurchaseItemIndex].item_id = e.id_crypt;
    this.state.purchase_order_item[PurchaseItemIndex].item_id = e.id;
    this.state.purchase_order_item[PurchaseItemIndex].hsn_code = e.hsn_code;
    this.state.purchase_order_item[PurchaseItemIndex].rate =
      e.sales_selling_price;
    this.state.purchase_order_item[PurchaseItemIndex].amount =
      e.sales_selling_price;
    this.state.purchase_order_item[PurchaseItemIndex].quantity = 1;
    this.calculateTax(PurchaseItemIndex);
  };

  handleInputSelectquantity = (PurchaseItemIndex) => (e) => {
    let qty = e.target.value;
    this.state.purchase_order_item[PurchaseItemIndex].quantity = qty;

    this.calculateTax(PurchaseItemIndex);
  };

  handleInputAmount = (PurchaseItemIndex) => (e) => {
    let price = e.target.value;
    this.state.purchase_order_item[PurchaseItemIndex].rate = price;
    this.calculateTax(PurchaseItemIndex);
  };

  handleinvoicetax = (PurchaseItemIndex) => (e) => {
    const taxListIndex = e.target.value;

    if (taxListIndex.length) {
      const Tax = this.state.invoiceTaxlist[taxListIndex];
      this.state.purchase_order_item[PurchaseItemIndex].gst_igst_common_value =
        Tax.gst_igst_common;
      this.state.purchase_order_item[PurchaseItemIndex].purchase_order_tax_id =
        Tax.id;
      this.state.purchase_order_item[
        PurchaseItemIndex
      ].purchase_tax_orgin_percentage = Tax.percentage;

      this.calculateTax(PurchaseItemIndex);
    } else {
      this.state.purchase_order_item[
        PurchaseItemIndex
      ].purchase_order_tax_id = 0;
      this.calculateTax(PurchaseItemIndex);
    }
  };

  calculateTax(PurchaseItemIndex) {
    //This is GST and IGST calculation
    if (
      this.state.purchase_order_item[PurchaseItemIndex].purchase_order_tax_id !=
      0
    ) {
      let qty = this.state.purchase_order_item[PurchaseItemIndex].quantity;
      let amount = this.state.purchase_order_item[PurchaseItemIndex].rate;
      let percentageOrgin =
        this.state.purchase_order_item[PurchaseItemIndex]
          .purchase_tax_orgin_percentage;

      if (
        this.state.purchase_order_item[PurchaseItemIndex]
          .gst_igst_common_value == 2
      ) {
        let tamount = qty * amount;
        let Taxamount = ((tamount / 100) * percentageOrgin).toFixed(2);

        this.state.purchase_order_item[PurchaseItemIndex].igst_amount =
          Taxamount;
        this.state.purchase_order_item[PurchaseItemIndex].igst_percentage =
          percentageOrgin;
      }

      if (
        this.state.purchase_order_item[PurchaseItemIndex]
          .gst_igst_common_value === 3
      ) {
        let percentage = (percentageOrgin / 2).toFixed(2);
        let tamount = qty * amount;
        let Taxamount = ((tamount / 100) * percentage).toFixed(2);

        this.state.purchase_order_item[PurchaseItemIndex].cgst_amount =
          Taxamount;
        this.state.purchase_order_item[PurchaseItemIndex].sgst_amount =
          Taxamount;
        this.state.purchase_order_item[PurchaseItemIndex].sgst_percentage =
          percentage;
        this.state.purchase_order_item[PurchaseItemIndex].cgst_percentage =
          percentage;
      }

      if (
        this.state.purchase_order_item[PurchaseItemIndex]
          .gst_igst_common_value === 1
      ) {
        this.state.purchase_order_item[PurchaseItemIndex].igst_amount = 0;
        this.state.purchase_order_item[PurchaseItemIndex].igst_percentage = 0;
        this.state.purchase_order_item[PurchaseItemIndex].cgst_amount = 0;
        this.state.purchase_order_item[PurchaseItemIndex].sgst_amount = 0;
        this.state.purchase_order_item[PurchaseItemIndex].sgst_percentage = 0;
        this.state.purchase_order_item[PurchaseItemIndex].cgst_percentage = 0;
      }
    }

    if (
      this.state.purchase_order_item[PurchaseItemIndex].purchase_order_tax_id ==
      0
    ) {
      this.state.purchase_order_item[PurchaseItemIndex].igst_amount = 0;
      this.state.purchase_order_item[PurchaseItemIndex].igst_percentage = 0;
      this.state.purchase_order_item[PurchaseItemIndex].cgst_amount = 0;
      this.state.purchase_order_item[PurchaseItemIndex].sgst_amount = 0;
      this.state.purchase_order_item[PurchaseItemIndex].sgst_percentage = 0;
      this.state.purchase_order_item[PurchaseItemIndex].cgst_percentage = 0;
      this.state.purchase_order_item[
        PurchaseItemIndex
      ].gst_igst_common_value = 0;
      this.state.purchase_order_item[
        PurchaseItemIndex
      ].purchase_tax_orgin_percentage = 0;
    }

    this.state.purchase_order_item[PurchaseItemIndex].amount =
      this.state.purchase_order_item[PurchaseItemIndex].quantity *
      this.state.purchase_order_item[PurchaseItemIndex].rate;

    this.calculateSubTotalTotal();
  }

  calculateSubTotalTotal() {
    let totalTax = 0;
    let subTotal = 0;

    this.state.purchase_order_item.map((item, sidx) => {
      if (item.gst_igst_common_value === 3) {
        totalTax = totalTax + parseFloat(item.cgst_amount);
        totalTax = totalTax + parseFloat(item.sgst_amount);
      }

      if (item.gst_igst_common_value === 2) {
        totalTax = totalTax + parseFloat(item.igst_amount);
      }

      subTotal = subTotal + item.amount;
    });

    this.setState({ sub_total: subTotal });
    this.setState({ totalTax: totalTax });
    this.setState({ total_tax_amount: totalTax });
    this.setState({ purchase_order_item: this.state.purchase_order_item });
  }

  totaltaxCalculation(itemList) {
    let totalTax = 0;

    itemList.map((item, sidx) => {
      if (item.gst_igst_common_value === 3) {
        totalTax = totalTax + item.cgst_amount;
        totalTax = totalTax + item.sgst_amount;
      }

      if (item.gst_igst_common_value === 2) {
        totalTax = totalTax + item.igst_amount;
      }
    });

    this.setState({ totalTax: totalTax });
    this.setState({ total_tax_amount: totalTax });
  }

  handleInputDescription = (PurchaseItemIndex) => (e) => {
    this.state.purchase_order_item[PurchaseItemIndex].description =
      e.target.value;

    this.setState({ purchase_order_item: this.state.purchase_order_item });
  };

  handleInputSelecthsn_code = (index) => (e) => {
    const itemsP = this.state.purchase_order_item.map((item, sidx) => {
      if (index !== sidx) {
        return item;
      }

      return { ...item, hsn_code: e.target.value };
    });

    this.setState({ purchase_order_item: itemsP });
  };

  handleInputinvoicedetails = (e) => {
    const token = localStorage.getItem("token");
    if (e.target.name === "branch_id") {
      this.setLoaderFunction();
      const res = axios
        .get("public/api/branch/warehouse/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.closeLoaderFuncion();
          this.setState({ warehouseList: res.data.warehouses });
        });
    }
    if (e.target.name === "warehouse_id") {
      this.setLoaderFunction();
      const res = axios
        .get("public/api/warehouse/and/non/inventory/items/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({
            itemLine: res.data.warehouse_and_non_inventory_items,
          });
        });
      this.closeLoaderFuncion();
    }

    if (e.target.name === "payment_terms_id") {
      if (e.target.value == 1) {
        console.log(moment(new Date()).format("YYYY-MM-DD"));

        this.state.expected_delivery_date = moment(new Date()).format(
          "YYYY-MM-DD"
        );
        this.setState({
          expected_delivery_date: this.state.expected_delivery_date,
        });
      } else {
        this.setState({
          expected_delivery_date: "",
        });
      }
      console.log(this.state.expected_delivery_date);
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleInputOne = (e) => {
    this.setState({
      query: e.target.value,
    });
  };

  handleInputtwo = (e) => {
    this.setState({
      queryItem: e.target.value,
    });
  };

  handleInputModalForItem = async (e) => {
    console.log(e);
    this.state.itemLine = [];
    if (e) {
      this.setState({ openvendor: false });
      const token = localStorage.getItem("token");
      const res = axios
        .get("public/api/items", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({ itemLine: res.data.items });
          this.setState({ openitem: false });
        });
    }
  };
  addItem = (e) => {
    this.setState({ openitem: true });
  };
  closeItem = (e) => {
    this.setState({ openitem: false });
  };

  addvendor = (e) => {
    this.setState({ openvendor: true });
  };

  closevendor = (e) => {
    this.setState({ openvendor: false });
  };

  saveItem = async (e) => {
    this.setLoaderFunction();
    e.preventDefault();
    //this.setState({vendor_id:this.state.selectedPerson['id_crypt']});
    this.state.total = this.state.sub_total + this.state.totalTax;
    this.state.balance_due = this.state.sub_total + this.state.totalTax;
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "public/api/purchase/order/store",
      this.state,
      { headers }
    );

    if (res.data.success) {
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.closeLoaderFuncion();
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.closeLoaderFuncion();
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };

  itemDelete = (PurchaseItemIndex) => (e) => {
    /*
let sub_total=0;
  const itemsP = this.state.purchase_order_item.map((item, sidx) => { 
    if(index===sidx){
      
    }else{
      let sqty=item.quantity;
      let sprice=item.rate;
      let stotal=sqty*sprice;
      sub_total=stotal+sub_total;
     
    }
  })
  this.setState({sub_total:sub_total});
  this.setState({
    item: this.state.purchase_order_item.filter((s, sidx) => index !== sidx)
  });
*/

    this.state.purchase_order_item = this.state.purchase_order_item.filter(
      (s, sidx) => PurchaseItemIndex !== sidx
    );
    this.calculateSubTotalTotal();

    this.setState({
      purchase_order_item: this.state.purchase_order_item,
    });
  };

  addLine = (e) => {
    //this.state.newLine.push({name:'Ram'},);
    //const xx={  name: '' , }
    // More users...
    //this.setState({newLine: [...this.state.newLine, xx]});

    this.setState({
      purchase_order_item: this.state.purchase_order_item.concat([
        {
          name: "",
          item_id: "",
          hsn_code: "",
          description: "",
          quantity: 1,
          discount_symbol_id: 1,
          discount_number: 0,
          rate: 0,
          purchase_order_tax_id: "",
          purchase_tax_orgin_percentage: "",
          gst_igst_common_value: "",
          cgst_percentage: 0,
          cgst_amount: 0,
          sgst_percentage: 0,
          sgst_amount: 0,
          igst_percentage: 0,
          igst_amount: 0,
          amount: 0,
        },
      ]),
    });
  };

  ItemErrorfetch(error_list, index) {
    var pea = `purchase_order_item.${index}.purchase_order_tax_id`;
    return error_list[pea];
  }

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      this.state.redirect = false;
      this.setState({ redirect: this.state.redirect });
      return <Navigate to={"/filterby/Purchaseorderlist"} />;
    }

    const filteredPeople =
      this.state.query === ""
        ? this.state.vendorList
        : this.state.vendorList.filter((vendorList) => {
            return vendorList.vendor_display_name
              .toLowerCase()
              .includes(this.state.query.toLowerCase());
          });

    const filteredItem =
      this.state.queryItem === ""
        ? this.state.itemLine
        : this.state.itemLine.filter((itemLine) => {
            return itemLine.name
              .toLowerCase()
              .includes(this.state.queryItem.toLowerCase());
          });

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          {/* Static sidebar for desktop */}

          <div className="flex flex-col flex-1">
            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* */}
                  <div></div>

                  {/* */}
                  <h1 className="text-2xl font-semibold text-gray-900">
                    {" "}
                    New Purchase Order
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>
                  <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                    <div className="md:grid md:gap-6">
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.saveItem}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="grid grid-cols-6 gap-6">
                                {/*start*/}
                                <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                  <Combobox
                                    as="div"
                                    name="vendor_id"
                                    value={this.state.selectedPerson}
                                    onChange={this.handleInput}
                                  >
                                    <Combobox.Label className="block text-sm font-medium text-gray-700">
                                      Vendor Name*
                                    </Combobox.Label>
                                    <div className="relative mt-1">
                                      <Combobox.Input
                                        className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                        onChange={this.handleInputOne}
                                        displayValue={(vendor) =>
                                          typeof vendor.vendor_display_name !==
                                            "undefined" &&
                                          vendor.vendor_display_name != null
                                            ? vendor.vendor_display_name
                                            : ""
                                        }
                                      />
                                      <Combobox.Button className="absolute inset-y-0 right-9 flex items-center rounded-r-md px-2 focus:outline-none">
                                        <SelectorIcon
                                          className="h-5 w-5 text-gray-400"
                                          aria-hidden="true"
                                        />
                                      </Combobox.Button>

                                      {filteredPeople.length > 0 && (
                                        <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                          {filteredPeople.map((vendor) => (
                                            <Combobox.Option
                                              key={vendor.id_crypt}
                                              value={vendor}
                                              className={({ active }) =>
                                                classNames(
                                                  "relative cursor-default select-none py-2 pl-3 pr-9",
                                                  active
                                                    ? "bg-indigo-600 text-white"
                                                    : "text-gray-900"
                                                )
                                              }
                                            >
                                              {({ active, selected }) => (
                                                <>
                                                  <span
                                                    className={classNames(
                                                      "block truncate",
                                                      selected &&
                                                        "font-semibold"
                                                    )}
                                                  >
                                                    {vendor.vendor_display_name}
                                                  </span>

                                                  {selected && (
                                                    <span
                                                      className={classNames(
                                                        "absolute inset-y-0 right-0 flex items-center pr-4",
                                                        active
                                                          ? "text-white"
                                                          : "text-indigo-600"
                                                      )}
                                                    >
                                                      <CheckIcon
                                                        className="h-5 w-5"
                                                        aria-hidden="true"
                                                      />
                                                    </span>
                                                  )}
                                                </>
                                              )}
                                            </Combobox.Option>
                                          ))}
                                        </Combobox.Options>
                                      )}
                                    </div>
                                  </Combobox>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                  <button
                                    type="button"
                                    onClick={this.addvendor}
                                    className="mt-5 inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    <PlusSmIconOutline
                                      className="h-6 w-6"
                                      aria-hidden="true"
                                    />
                                  </button>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="branch_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Branch
                                  </label>
                                  <select
                                    id="branch_id"
                                    name="branch_id"
                                    onChange={this.handleInputinvoicedetails}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.branchList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.branch_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="warehouse_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Warehouse*
                                  </label>
                                  <select
                                    id="Type"
                                    name="warehouse_id"
                                    onChange={this.handleInputinvoicedetails}
                                    autoComplete=""
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.warehouseList.map((number) => (
                                      <option value={number.id}>
                                        {number.warehouse_name}
                                      </option>
                                    ))}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list.warehouse_id}
                                    </p>
                                  </select>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="transaction_series_number"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Purchase Order#*
                                  </label>
                                  <input
                                    type="text"
                                    name="transaction_series_number"
                                    id="transaction_series_number"
                                    onChange={this.handleInputinvoicedetails}
                                    autoComplete="transaction_series_number"
                                    disabled
                                    value={this.state.transaction_series_number}
                                    className="mt-1 focus:ring-indigo-500 disabled:bg-slate-50 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="transaction_series_number-error"
                                  >
                                    {
                                      this.state.error_list
                                        .transaction_series_number
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="purchase_order_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Date
                                  </label>
                                  <input
                                    type="Date"
                                    name="purchase_order_date"
                                    id="purchase_order_date"
                                    onChange={this.handleInputinvoicedetails}
                                    autoComplete="purchase_order_date"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="purchase_order_date-error"
                                  >
                                    {this.state.error_list.purchase_order_date}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="payment_terms_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Terms
                                  </label>
                                  <select
                                    id="payment_terms_id"
                                    name="payment_terms_id"
                                    onChange={this.handleInputinvoicedetails}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                  >
                                    <option value="0">------</option>
                                    {this.state.termsList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.payment_terms_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="expected_delivery_date"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Expected Delivery Date
                                  </label>
                                  <input
                                    type="Date"
                                    name="expected_delivery_date"
                                    id="expected_delivery_date"
                                    value={this.state.expected_delivery_date}
                                    onChange={this.handleInputinvoicedetails}
                                    autoComplete="expected_delivery_date"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="expected_delivery_date-error"
                                  >
                                    {
                                      this.state.error_list
                                        .expected_delivery_date
                                    }
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label
                                      htmlFor="employee_id"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      
                                      Employee 
                                      
                                    </label>
                                    <select
                                      id="employee_id"
                                      name="employee_id"
                                      onChange={this.handleInputinvoicedetails}
                                      className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    >
                                      <option value="0">------</option>
                                      {this.state.employeeList.map((number) => (
                                        <option value={number.id}>{number.name}</option>
                                      ))}
                                    </select>
                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="employee_id-error"
                                    >
                                      {this.state.error_list.employee_id}
                                    </p>
                                  </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-6">
                                  <div className="-mx-4 mt-8 flex flex-col sm:-mx-6 md:mx-0">
                                    <table className="min-w-full divide-y divide-gray-300">
                                      <thead>
                                        <tr>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                          >
                                            ITEM DETAILS
                                          </th>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                          >
                                            Add
                                          </th>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                          >
                                            DESC
                                          </th>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
                                          >
                                            HSN/SAC
                                          </th>
                                          <th
                                            scope="col"
                                            className="hidden py-3.5 px-3  text-sm font-semibold text-gray-900 sm:table-cell"
                                          >
                                            QUANTITY
                                          </th>
                                          <th
                                            scope="col"
                                            className="hidden py-3.5 px-3  text-sm font-semibold text-gray-900 sm:table-cell"
                                          >
                                            RATE
                                          </th>
                                          <th
                                            scope="col"
                                            className="hidden py-3.5 px-3  text-sm font-semibold text-gray-900 sm:table-cell"
                                          >
                                            TAX
                                          </th>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-3 pr-4  text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                          >
                                            AMOUNT
                                          </th>
                                          <th
                                            scope="col"
                                            className="py-3.5 pl-3 pr-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="h-5 w-5"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                                            </svg>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.purchase_order_item.map(
                                          (Itemsi, index) => (
                                            <tr
                                              key={index}
                                              className="border-b border-gray-200"
                                            >
                                              <td className="py-4 pl-4 pr-3 text-sm sm:pl-6 md:pl-0">
                                                <Combobox
                                                  as="div"
                                                  value={Itemsi}
                                                  onChange={this.handleInputSelectItem(
                                                    index
                                                  )}
                                                >
                                                  <Combobox.Label className="block text-sm font-medium text-gray-700"></Combobox.Label>
                                                  <div className="relative mt-1">
                                                    <Combobox.Input
                                                      className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                                      onChange={
                                                        this.handleInputtwo
                                                      }
                                                      displayValue={(Items) =>
                                                        typeof Items.name !==
                                                          "undefined" &&
                                                        Items.name != null
                                                          ? Items.name
                                                          : ""
                                                      }
                                                    />
                                                    <Combobox.Button className="absolute inset-y-0 right-9 flex items-center rounded-r-md px-2 focus:outline-none">
                                                      <SelectorIcon
                                                        className="h-5 w-5 text-gray-400"
                                                        aria-hidden="true"
                                                      />
                                                    </Combobox.Button>
                                                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                                      <PlusIcon
                                                        className="h-5 w-5 text-gray-400"
                                                        aria-hidden="true"
                                                      />
                                                    </div>

                                                    {filteredItem.length >
                                                      0 && (
                                                      <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                        {filteredItem.map(
                                                          (itemLine) => (
                                                            <Combobox.Option
                                                              key={
                                                                itemLine.id_crypt
                                                              }
                                                              value={itemLine}
                                                              className={({
                                                                active,
                                                              }) =>
                                                                classNames(
                                                                  "relative cursor-default select-none py-2 pl-3 pr-9",
                                                                  active
                                                                    ? "bg-indigo-600 text-white"
                                                                    : "text-gray-900"
                                                                )
                                                              }
                                                            >
                                                              {({
                                                                active,
                                                                selected,
                                                              }) => (
                                                                <>
                                                                  <span
                                                                    className={classNames(
                                                                      "block truncate",
                                                                      selected &&
                                                                        "font-semibold"
                                                                    )}
                                                                  >
                                                                    {
                                                                      itemLine.name
                                                                    }
                                                                  </span>

                                                                  {selected && (
                                                                    <span
                                                                      className={classNames(
                                                                        "absolute inset-y-0 right-0 flex items-center pr-4",
                                                                        active
                                                                          ? "text-white"
                                                                          : "text-indigo-600"
                                                                      )}
                                                                    >
                                                                      <CheckIcon
                                                                        className="h-5 w-5"
                                                                        aria-hidden="true"
                                                                      />
                                                                    </span>
                                                                  )}
                                                                </>
                                                              )}
                                                            </Combobox.Option>
                                                          )
                                                        )}
                                                      </Combobox.Options>
                                                    )}
                                                  </div>
                                                </Combobox>
                                              </td>
                                              <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                                <button
                                                  type="button"
                                                  onClick={this.addItem}
                                                  className="float-right mt-4 inline-flex items-center p-.05 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                >
                                                  <PlusSmIconOutline
                                                    className="h-6 w-6"
                                                    aria-hidden="true"
                                                  />
                                                </button>
                                              </td>
                                              <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                                <input
                                                  type="text"
                                                  name="description"
                                                  onChange={this.handleInputDescription(
                                                    index
                                                  )}
                                                  value={Itemsi.description}
                                                  id="description"
                                                  autoComplete="description"
                                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                />
                                              </td>
                                              <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                                <input
                                                  type="text"
                                                  name="hsn_code"
                                                  onChange={this.handleInputSelecthsn_code(
                                                    index
                                                  )}
                                                  value={Itemsi.hsn_code}
                                                  id="hsn_code"
                                                  autoComplete="hsn_code"
                                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                />
                                              </td>
                                              <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                                <input
                                                  type="number"
                                                  name="quantity"
                                                  onChange={this.handleInputSelectquantity(
                                                    index
                                                  )}
                                                  value={Itemsi.quantity}
                                                  id="quantity"
                                                  autoComplete="quantity"
                                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                />
                                              </td>

                                              <td className="hidden py-4 px-3 text-right text-sm text-gray-500 sm:table-cell">
                                                <input
                                                  type="number"
                                                  name="rate"
                                                  onChange={this.handleInputAmount(
                                                    index
                                                  )}
                                                  value={Itemsi.rate}
                                                  id="rate"
                                                  autoComplete="rate"
                                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                />
                                              </td>
                                              <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                <select
                                                  id="invoiceTax"
                                                  name="invoiceTax"
                                                  onChange={this.handleinvoicetax(
                                                    index
                                                  )}
                                                  autoComplete="invoiceTax"
                                                  className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                >
                                                  <option value="">
                                                    ------
                                                  </option>
                                                  {this.state.invoiceTaxlist.map(
                                                    (number, index) => (
                                                      <option value={index}>
                                                        {number.name}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                                <p
                                                  className="mt-2 text-sm text-red-600"
                                                  id="invoiceTax-error"
                                                >
                                                  {this.ItemErrorfetch(
                                                    this.state.error_list,
                                                    index
                                                  )}
                                                </p>
                                              </td>
                                              <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                {Itemsi.amount}
                                              </td>
                                              <td className="py-4 pl-3 pr-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  onClick={this.itemDelete(
                                                    index
                                                  )}
                                                  className="h-6 w-6"
                                                  fill="none"
                                                  viewBox="0 0 24 24"
                                                  stroke="currentColor"
                                                  strokeWidth={2}
                                                >
                                                  <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                  />
                                                </svg>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td>
                                            <button
                                              type="button"
                                              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                              onClick={this.addLine}
                                            >
                                              <PlusIcon
                                                className="-ml-1 mr-2 h-5 w-5"
                                                aria-hidden="true"
                                              />
                                              Add New Line
                                            </button>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th
                                            scope="row"
                                            colSpan={4}
                                            className="hidden pl-6 pr-3 pt-6 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                          >
                                            Subtotal
                                          </th>
                                          <th
                                            scope="row"
                                            className="pl-4 pr-3 pt-6 text-left text-sm font-normal text-gray-500 sm:hidden"
                                          >
                                            Subtotal
                                          </th>
                                          <td className="pl-3 pr-4 pt-6 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                            {this.state.sub_total}
                                          </td>
                                        </tr>

                                        {this.state.purchase_order_item.map(
                                          (Itemsi, index) =>
                                            Itemsi.gst_igst_common_value ===
                                            2 ? (
                                              <tr>
                                                <th
                                                  scope="row"
                                                  colSpan={4}
                                                  className="hidden pl-6 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                                >
                                                  IGST
                                                  {Itemsi.igst_percentage}
                                                </th>
                                                <th
                                                  scope="row"
                                                  className="pl-4 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden"
                                                >
                                                  {Itemsi.igst_percentage}
                                                </th>
                                                <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                  {Itemsi.igst_amount}
                                                </td>
                                              </tr>
                                            ) : (
                                              ""
                                            )
                                        )}

                                        {this.state.purchase_order_item.map(
                                          (Itemsi, index) =>
                                            Itemsi.gst_igst_common_value ===
                                            3 ? (
                                              <tr>
                                                <th
                                                  scope="row"
                                                  colSpan={4}
                                                  className="hidden pl-6 pr-3 pt-4 text-right text-sm font-normal text-gray-500 sm:table-cell md:pl-0"
                                                >
                                                  GST{" "}
                                                  {Itemsi.cgst_percentage * 2}%
                                                </th>
                                                <th
                                                  scope="row"
                                                  className="pl-4 pr-3 pt-4 text-left text-sm font-normal text-gray-500 sm:hidden"
                                                >
                                                  GST{" "}
                                                  {Itemsi.cgst_percentage * 2}%
                                                </th>

                                                <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                  CGST:{Itemsi.cgst_amount}
                                                </td>

                                                <td className="pl-3 pr-4 pt-4 text-right text-sm text-gray-500 sm:pr-6 md:pr-0">
                                                  SGST:{Itemsi.sgst_amount}
                                                </td>
                                              </tr>
                                            ) : (
                                              ""
                                            )
                                        )}

                                        <tr>
                                          <th
                                            scope="row"
                                            colSpan={4}
                                            className="hidden pl-6 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell md:pl-0"
                                          >
                                            Total
                                          </th>
                                          <th
                                            scope="row"
                                            className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden"
                                          >
                                            Total
                                          </th>
                                          <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-6 md:pr-0">
                                            {
                                              (this.state.total =
                                                this.state.totalTax +
                                                this.state.sub_total)
                                            }
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <div className="pt-8">
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="customer_notes"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Customer Notes
                                    </label>
                                    <div className="mt-1">
                                      <textarea
                                        rows={2}
                                        name="customer_notes"
                                        id="customer_notes"
                                        onChange={
                                          this.handleInputinvoicedetails
                                        }
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                        defaultValue={""}
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="terms_conditions"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Terms & Conditions
                                    </label>
                                    <div className="mt-1">
                                      <textarea
                                        rows={2}
                                        name="terms_conditions"
                                        id="terms_conditions"
                                        onChange={
                                          this.handleInputinvoicedetails
                                        }
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                        defaultValue={""}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-3">
                              <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/*start vendorCreate modal */}

        <Transition.Root show={this.state.openvendor} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={this.closevendor}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>
                      <Vendorscreatemodal
                        handleInputPurchaseOrder={this.handleInputModal}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/*End vendorCreate modal */}

        {/*Item */}
        <Transition.Root show={this.state.openitem} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={this.closeItem}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>
                      <ItemModalcreate
                        handleInputInvoiceItem={this.handleInputModalForItem}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/*Item */}
      </>
    );
  }
}

export default Purchaseorder;
